import React, { Fragment as _, useContext } from 'react';

import { interactionContext } from './interactionContext';
import { Box } from 'theme-ui';

import EditableBtn from '../EditableBtn';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import getBlockById from 'services/apiHelpers/getBlockById';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import { State } from 'store/store';
import { Block } from '@chameleoncreator/creator-app';
import { useSelector, useDispatch } from 'react-redux';
import { updateAssessmentAction } from 'actions/updateAssessmentAction';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';

const ContinueButtonBranching = props => {
  const context = useContext(interactionContext) as any;
  // console.log('ContinueButtonBranching :', context);

  const { passed } = context;
  const { enableBranching, correctColor, incorrectColor } = context.props;

  const { children } = props;
  const [defaultBtn, passedBtn, failedBtn] = children;

  if (!enableBranching) {
    return defaultBtn;
  }

  const branchingBtn =
    passed === true || passed === undefined ? passedBtn : failedBtn;

  let Btn = branchingBtn;

  if (window.dev && window.dev()) {
    Btn = (
      <Box
        sx={{
          // boxShadow: `inset 0 0 0 5px ${
          //   passed ? correctColor : incorrectColor
          // }`,

          // background: passed ? correctColor : incorrectColor,

          '*': {
            boxShadow: 'none !important',
          },

          boxShadow: `0 0 0 1px ${passed ? correctColor : incorrectColor}`,
        }}
      >
        {branchingBtn}
      </Box>
    );
  }

  return Btn;
  // passed === true || passed === undefined ? children[0] : children[1];
};

export default ContinueButtonBranching;
